import { ModalFooterProps } from "modals/footer/types";
import { Component } from "react";
import { connect } from "react-redux";
import { AppState } from "types/app";
import "./ModalFooter.css";

const mapStateToProps = (state:AppState):ModalFooterProps.Redux => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
	};
};

class ModalFooter extends Component<ModalFooterProps.Component> {
	render():JSX.Element{
		return (
			<div className="modal-footer">
				{this.props.children}
			</div>
		);
	}


}
export default connect(mapStateToProps)(ModalFooter);
